import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgListBullet = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 17.996h12M8 11.996h12M8 5.996h12M4.011 5.981v.064m.26-.05a.26.26 0 1 1-.522 0 .26.26 0 0 1 .522 0M4.011 12.11v.064m.26-.05a.26.26 0 1 1-.522 0 .26.26 0 0 1 .522 0M4.011 17.981v.064m.26-.05a.26.26 0 1 1-.522 0 .26.26 0 0 1 .522 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgListBullet);
export default ForwardRef;
